import React from 'react';
import { useTranslation } from 'services/localization';
import { Box, xcss } from '@atlaskit/primitives';
import { default as AtlasTabs, TabList, TabProps, useTab } from '@atlaskit/tabs';

const tabsStyles = xcss({
  paddingBottom: 'space.200',
});

const Tab = (props: TabProps) => {
  const tabAttributes = useTab();
  return <Box {...tabAttributes} {...props} />;
};

export interface OwnProps {
  tabKeys: string[];
  groupKey: string | undefined;
  onChange: (tab: string, group: string) => void;
}

const Tabs = ({ tabKeys, groupKey, onChange }: OwnProps) => {
  const { translate, keyWithTitle } = useTranslation();

  if (tabKeys.length < 2) return null;

  const sortedTabsMeta: string[] = [...tabKeys].sort((left, right) => left.localeCompare(right));
  const groupTabsTestId = 'groupTabsTestId';

  function handleOnChange(index: number) {
    onChange(sortedTabsMeta[index], groupKey || '');
  }

  return (
    <Box xcss={tabsStyles}>
      <AtlasTabs onChange={handleOnChange} id={(groupKey || 'default') + '_tabs'} testId={groupTabsTestId}>
        <TabList>
          {sortedTabsMeta.map((key) => (
            <Tab key={key} testId={groupTabsTestId + `-${key}-tab`}>
              {translate(keyWithTitle(key))}
            </Tab>
          ))}
        </TabList>
      </AtlasTabs>
    </Box>
  );
};

export default Tabs;
